import { createSlice } from '@reduxjs/toolkit';

export const notificationMessageSlice = createSlice({
    name: 'notificationMessage',
    initialState: {
        notification: {
            text: '',
            color: 'success',
            visible: false,
            onDismiss: null
        }
    },
    reducers: {
        setNotification: (state, action) => {
            state.notification = action.payload;
        }
    },
});

export const selectNotification = state => state.notificationMessage.notification;
export const { setNotification } = notificationMessageSlice.actions;
export const showMessage = ({text, color, duration, onDismiss}) => dispatch => {
    dispatch(setNotification({text, color, visible: true, onDismiss})); 
    setTimeout(() => {
      dispatch(setNotification({text, color, visible: false, onDismiss}));
    }, duration | 2000);
  };
  
export default notificationMessageSlice.reducer;